<script setup lang="ts">
import type { ButtonSizes } from '@ui/styles/Styles'
import { useCalendarFilters } from '@plf/components/calendar/shared/useCalendarFilters'

withDefaults(
  defineProps<{
    size?: ButtonSizes
  }>(),
  {
    size: Sizes.HanSolo,
  },
)

const { filters, resetDate, isPeriod } = useCalendarFilters()
</script>

<template lang="pug">
UiInputDate.input-date(v-model="filters.date" :size="size" :background="isLtLg ? Background.White : Background.Outline" :range="isPeriod" :weekday="!isPeriod" :icon="false" :arrows="true" :placements="[Placements.BottomEnd, Placements.BottomStart]")
UiButton.reset.o-1(label="general.today" :variant="ButtonVariant.Secondary" :size="size" @click="resetDate")
</template>

<style scoped>
.input-date {
  :deep(.input) {
    --uno: text-center;
  }

  @screen lt-lg {
    :deep(.input-container) {
      border: none !important;
    }
  }

  @screen at-sm {
    --uno: max-w-248 o-2;
  }
  @screen at-md {
    --uno: max-w-248 o-2;
  }
}

.reset {
  @screen lt-sm {
    --uno: d-none;
  }

  @screen at-lg {
    --uno: d-none;
  }
}
</style>
